import React, { useState, useEffect } from 'react';
import { 
  MapPin, Moon, Sun, Clock, Heart, Star, ShieldCheck, 
  CalendarDays, X, BookHeart, ListChecks, MessageCircle, 
  ChevronDown, ChevronUp, AlertCircle, Play, Pause, RotateCcw, BookOpen
} from 'lucide-react';

const urduOrdinals = [
  "", "پہلی", "دوسری", "تیسری", "چوتھی", "پانچویں", "چھٹی", "ساتویں", "آٹھویں", "نویں", "دسویں", 
  "گیارہویں", "بارہویں", "تیرہویں", "چودہویں", "پندرہویں", "سولہویں", "سترہویں", "اٹھارہویں", "انیسویں", "بیسویں", 
  "اکیسویں", "بائیسویں", "تیئیسویں", "چوبیسویں", "پچیسویں", "چھبیسویں", "ستائیسویں", "اٹھائیسویں", "انتیسویں", "تیسویں"
];

// ✅ English days ko Urdu days mein tabdeel karne ke liye
const urduDays = {
  "Monday": "پیر",
  "Tuesday": "منگل",
  "Wednesday": "بدھ",
  "Thursday": "جمعرات",
  "Friday": "جمعہ",
  "Saturday": "سنیچر",
  "Sunday": "اتوار"
};

const RamadanTimes = ({ setActiveTab }) => {
  const [locationName, setLocationName] = useState('Shirpur, Maharashtra');
  const [timings, setTimings] = useState(null);
  const [hijriData, setHijriData] = useState(null);
  const [timetable, setTimetable] = useState([]); 
  const [showModal, setShowModal] = useState(false); 
  const [isLoading, setIsLoading] = useState(true);
  const [showPrivateMasail, setShowPrivateMasail] = useState(false); 
  
  const [expandedZikr, setExpandedZikr] = useState(null);
  const [playingZikr, setPlayingZikr] = useState(null);
  const [astaghfarCount, setAstaghfarCount] = useState(0);
  
  const [nextEvent, setNextEvent] = useState({ title: '', diff: '', type: '' });
  
  const ramadanDuas = {
    sehri: {
      title: "روزہ رکھنے کی دعا",
      arabic: "وَبِصَوْمِ غَدٍ نَّوَيْتُ مِنْ شَهْرِ رَمَضَانَ",
      urdu: "اور میں نے ماہ رمضان کے کل کے روزے کی نیت کی۔"
    },
    iftar: {
      title: "روزہ کھولنے کی دعا",
      arabic: "اللَّهُمَّ إِنِّي لَكَ صُمْتُ وَبِكَ آمَنْتُ وَعَلَيْكَ تَوَكَّلْتُ وَعَلَى رِزْقِكَ أَفْطَرْتُ",
      urdu: "اے اللہ! میں نے تیرے لیے روزہ رکھا، تجھ پر ایمان لایا، تجھ پر بھروسہ کیا اور تیرے دیے ہوئے رزق سے افطار کیا۔"
    }
  };

  const extraDuas = [
    {
      title: "نمازِ تراویح کی دعا",
      arabic: "سُبْحَانَ ذِي الْمُلْكِ وَالْمَلَكُوتِ، سُبْحَانَ ذِي الْعِزَّةِ وَالْعَظَمَةِ وَالْهَيْبَةِ وَالْقُدْرَةِ وَالْكِبْرِيَاءِ وَالْجَبَرُوتِ",
      urdu: "پاک ہے وہ ذات جو بادشاہی اور فرشتوں کے عالم کا مالک ہے، پاک ہے وہ ذات جو عزت، بڑائی، ہیبت، قدرت، اور دبدبے والی ہے۔"
    },
    {
      title: "شبِ قدر کی دعا",
      arabic: "اللَّهُمَّ إِنَّكَ عَفُوٌّ تُحِبُّ الْعَفْوَ فَاعْفُ عَنِّي",
      urdu: "اے اللہ! بے شک تو معاف کرنے والا ہے اور معاف کرنے کو پسند کرتا ہے، پس مجھے معاف فرما دے۔"
    }
  ];

  const masailList = [
    "بھول کر کھا یا پی لینے سے روزہ نہیں ٹوٹتا، یاد آنے پر فوراً رک جائیں۔",
    "روزے کی حالت میں مسواک کرنا یا عطر (Perfume) لگانا بالکل جائز ہے۔",
    "بیماری کی حالت میں انجکشن (Injection) یا ڈرپ لگوانے سے روزہ فاسد نہیں ہوتا۔",
    "اگر خود بخود قے (Vomit) آ جائے تو روزہ نہیں ٹوٹتا، البتہ جان بوجھ کر قے کرنے سے ٹوٹ جاتا ہے۔",
    "نہاتے وقت اگر غلطی سے پانی حلق میں چلا جائے تو روزہ ٹوٹ جاتا ہے، اس کی قضا لازم ہے۔"
  ];

  const masailKhawateen = [
    { title: "مخصوص ایام (حیض و نفاس):", desc: "ان ایام میں خواتین کے لیے روزہ رکھنا منع ہے، تاہم پاک ہونے کے بعد رمضان کے بعد ان روزوں کی قضا رکھنا فرض ہے۔" },
    { title: "حاملہ یا دودھ پلانے والی عورت:", desc: "اگر جان یا بچے کو نقصان کا سخت اندیشہ ہو تو روزہ چھوڑنے کی اجازت ہے، لیکن بعد میں قضا لازمی ہے۔" }
  ];

  const masailMard = [
    { title: "احتلام (Nightfall):", desc: "روزے کی حالت میں اگر سوتے ہوئے احتلام ہو جائے تو روزہ نہیں ٹوٹتا، البتہ پاکی کے لیے غسل فرض ہو جاتا ہے۔" }
  ];

  const masailShared = [
    { title: "میاں بیوی کے معاملات:", desc: "روزے کی حالت میں ہمبستری (Intercourse) کرنے سے روزہ ٹوٹ جاتا ہے اور قضا کے ساتھ کفارہ (مسلسل 60 روزے) بھی لازم آتا ہے۔" },
    { title: "دوا کا استعمال:", desc: "شرمگاہ کے راستے کوئی دوا یا ڈراپ (Suppositories) ڈالنے سے روزہ ٹوٹ جاتا ہے۔" }
  ];

  const zikrData = {
    kalma: {
        title: "تیسرا کلمہ", desc: "چلتے پھرتے کثرت سے پڑھیں۔",
        arabic: "سُبْحَانَ اللَّهِ وَالْحَمْدُ لِلَّهِ وَلَا إِلَهَ إِلَّا اللَّهُ وَاللَّهُ أَكْبَرُ وَلَا حَوْلَ وَلَا قُوَّةَ إِلَّا بِاللَّهِ الْعَلِيِّ الْعَظِيمِ",
        urdu: "اللہ پاک ہے، سب تعریفیں اللہ کے لیے ہیں، اللہ کے سوا کوئی معبود نہیں، اللہ سب سے بڑا ہے، اور گناہوں سے بچنے اور نیک کام کرنے کی طاقت اللہ ہی کی طرف سے ہے۔"
    },
    astaghfar: {
        title: "استغفار (100 مرتبہ)", desc: "روزانہ کم از کم 100 مرتبہ پڑھیں۔",
        arabic: "أَسْتَغْفِرُ اللَّهَ رَبِّي مِنْ كُلِّ ذَنْبٍ وَأَتُوبُ إِلَيْهِ",
        urdu: "میں اللہ سے اپنے تمام گناہوں کی بخشش مانگتا ہوں جو میرا رب ہے اور اسی کی طرف توبہ کرتا ہوں۔"
    },
    durood: {
        title: "درود شریف", desc: "جمعہ کے دن اور افطار سے پہلے کثرت سے پڑھیں۔",
        arabic: "اللَّهُمَّ صَلِّ عَلَى مُحَمَّدٍ وَعَلَى آلِ مُحَمَّدٍ كَمَا صَلَّيْتَ عَلَى إِبْرَاهِيمَ وَعَلَى آلِ إِبْرَاهِيمَ إِنَّكَ حَمِيدٌ مَجِيدٌ",
        urdu: "اے اللہ! رحمت نازل فرما محمد ﷺ پر اور ان کی آل پر، جس طرح تو نے رحمت نازل فرمائی ابراہیم علیہ السلام اور ان کی آل پر، بے شک تو تعریف کے لائق اور بزرگی والا ہے۔"
    }
  };

  const getAshraDetails = (day) => {
    if (day <= 10) return { 
       number: "پہلا عشرہ", name: "رحمت", 
       dua: "رَبِّ اغْفِرْ وَارْحَمْ وَأَنْتَ خَيْرُ الرَّاحِمِينَ", 
       fazilat: "پہلا عشرہ اللہ کی رحمت کا ہے۔ اس میں کثرت سے اللہ کی رحمت طلب کرنی چاہیے اور دوسروں پر بھی رحم کرنا چاہیے۔" 
    };
    if (day <= 20) return { 
       number: "دوسرا عشرہ", name: "مغفرت", 
       dua: "أَسْتَغْفِرُ اللهَ رَبِّي مِنْ كُلِّ ذَنْبٍ وَأَتُوبُ إِلَيْهِ", 
       fazilat: "یہ مغفرت کا عشرہ ہے۔ اس میں سچے دل سے توبہ کریں، اللہ ہر گناہ معاف فرمانے والا ہے۔" 
    };
    return { 
       number: "تیسرا عشرہ", name: "جہنم سے نجات", 
       dua: "اَللَّهُمَّ أَجِرْنِي مِنَ النَّارِ", 
       fazilat: "یہ جہنم سے آزادی کا عشرہ ہے، اسی میں لیلۃ القدر (شبِ قدر) تلاش کی جاتی ہے جو ہزار مہینوں سے بہتر ہے۔" 
    };
  };

  const fetchTimes = async (lat, lon, displayName) => {
    setIsLoading(true);
    try {
      const todayRes = await fetch(`https://api.aladhan.com/v1/timings?latitude=${lat}&longitude=${lon}&method=1&school=1`);
      const todayData = await todayRes.json();
      
      const febRes = await fetch(`https://api.aladhan.com/v1/calendar?latitude=${lat}&longitude=${lon}&method=1&school=1&month=2&year=2026`);
      const febData = await febRes.json();
      
      const marRes = await fetch(`https://api.aladhan.com/v1/calendar?latitude=${lat}&longitude=${lon}&method=1&school=1&month=3&year=2026`);
      const marData = await marRes.json();
      
      if (todayData.code === 200 && febData.code === 200 && marData.code === 200) {
        const t = todayData.data.timings;
        setTimings({ sehri: t.Imsak.split(' ')[0], iftar: t.Maghrib.split(' ')[0] });
        setHijriData(todayData.data.date.hijri);
        setLocationName(displayName);

        const combinedCalendar = [...febData.data, ...marData.data];
        const startIndex = combinedCalendar.findIndex(d => d.date.gregorian.date === '19-02-2026');
        
        if (startIndex !== -1) {
            const ramadan30Days = combinedCalendar.slice(startIndex, startIndex + 30);
            setTimetable(ramadan30Days);
        }
      }
    } catch (error) {
      console.error("Error fetching Ramadan times", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const savedLocation = localStorage.getItem('saved_namaz_location');
    if (savedLocation) {
      try {
        const { lat, lon, displayName } = JSON.parse(savedLocation);
        fetchTimes(lat, lon, displayName);
      } catch (e) {
        fetchTimes(21.3463, 74.8780, 'Shirpur, Maharashtra');
      }
    } else {
      fetchTimes(21.3463, 74.8780, 'Shirpur, Maharashtra');
    }
  }, []);

  const ramadanStartDate = new Date('2026-02-19T00:00:00');
  const now = new Date();
  const diffTime = now.getTime() - ramadanStartDate.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  let isRamadan = false;
  let currentRozaDay = 1;

  if (diffDays >= 0 && diffDays < 30) {
     isRamadan = true;
     currentRozaDay = diffDays + 1;
  } else if (diffDays < 0) {
     isRamadan = false;
     currentRozaDay = 1;
  } else {
     isRamadan = false; 
     currentRozaDay = 1;
  }

  useEffect(() => {
    if (!timings) return;
    const timer = setInterval(() => {
      const rightNow = new Date();
      const currentStr = `${rightNow.getHours().toString().padStart(2, '0')}:${rightNow.getMinutes().toString().padStart(2, '0')}:${rightNow.getSeconds().toString().padStart(2, '0')}`;
      
      let targetTime, type, title;
      const sehriFull = `${timings.sehri}:00`;
      const iftarFull = `${timings.iftar}:00`;

      if (currentStr < sehriFull) {
        targetTime = sehriFull; type = 'sehri'; 
        title = isRamadan ? `${urduOrdinals[currentRozaDay] || currentRozaDay} سحری ختم ہونے میں:` : "سحری ختم ہونے میں:";
      } else if (currentStr < iftarFull) {
        targetTime = iftarFull; type = 'iftar'; 
        title = isRamadan ? `${urduOrdinals[currentRozaDay] || currentRozaDay} افطار میں:` : "افطار میں:";
      } else {
        targetTime = sehriFull; type = 'sehri_next'; 
        let nextDay = isRamadan ? currentRozaDay + 1 : 1;
        title = isRamadan ? `${urduOrdinals[nextDay] || nextDay} سحری میں:` : "اگلی سحری میں:";
      }

      let [tH, tM, tS] = targetTime.split(':').map(Number);
      let diffH = tH - rightNow.getHours();
      let diffM = tM - rightNow.getMinutes();
      let diffS = (tS || 0) - rightNow.getSeconds();

      if (diffS < 0) { diffS += 60; diffM -= 1; }
      if (diffM < 0) { diffM += 60; diffH -= 1; }
      if (diffH < 0) diffH += 24;

      const pad = (num) => num.toString().padStart(2, '0');
      setNextEvent({ title, diff: `${pad(diffH)}:${pad(diffM)}:${pad(diffS)}`, type });
    }, 1000);

    return () => clearInterval(timer);
  }, [timings, currentRozaDay, isRamadan]);

  const format12Hour = (time24) => {
    if (!time24) return "";
    let [hours, minutes] = time24.split(':');
    hours = parseInt(hours);
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return `${hours}:${minutes} ${ampm}`;
  };

  const getAudioUrl = (text) => {
    return `https://translate.google.com/translate_tts?ie=UTF-8&tl=ar&client=tw-ob&q=${encodeURIComponent(text)}`;
  };

  const toggleZikrAccordion = (id) => {
    setExpandedZikr(expandedZikr === id ? null : id);
  };

  const toggleAudio = (id) => {
    const audio = document.getElementById(`audio_${id}`);
    if (!audio) return;

    if (playingZikr === id) {
        audio.pause();
        setPlayingZikr(null);
    } else {
        if (playingZikr) {
            const oldAudio = document.getElementById(`audio_${playingZikr}`);
            if (oldAudio) {
                oldAudio.pause();
                oldAudio.currentTime = 0;
            }
        }
        if (id === 'astaghfar' && astaghfarCount >= 100) {
            setAstaghfarCount(0);
        }
        
        audio.currentTime = 0;
        audio.play().then(() => {
            setPlayingZikr(id);
        }).catch(err => {
            alert("پلے کرنے میں مسئلہ آ رہا ہے۔");
        });
    }
  };

  const handleAstaghfarEnded = (e) => {
    setAstaghfarCount(prev => {
        const next = prev + 1;
        if (next < 100) {
            setTimeout(() => {
                e.target.play().catch(err => console.log(err));
            }, 800); 
        } else {
            setPlayingZikr(null);
        }
        return next;
    });
  };

  const openQuran = () => {
    if (setActiveTab) {
      setActiveTab('quran');
    }
  };

  if (isLoading) {
    return (
      <div className="loading-screen" style={{height: '60vh', display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center'}}>
         <div className="premium-loader" style={{transform: 'scale(0.8)'}}></div>
         <p style={{marginTop:'10px', color:'var(--gold-primary)', fontFamily: "'Noto Nastaliq Urdu', serif", fontSize: '0.8rem'}}>ڈیٹا لایا جا رہا ہے...</p>
      </div>
    );
  }

  const ashra = getAshraDetails(currentRozaDay);

  return (
    <>
      <audio id="audio_kalma" src={getAudioUrl(zikrData.kalma.arabic)} onEnded={() => setPlayingZikr(null)} />
      <audio id="audio_astaghfar" src={getAudioUrl(zikrData.astaghfar.arabic)} onEnded={handleAstaghfarEnded} />
      <audio id="audio_durood" src={getAudioUrl(zikrData.durood.arabic)} onEnded={() => setPlayingZikr(null)} />

      <style>{`
        .timetable-modal-overlay {
          position: fixed; top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0, 0, 0, 0.7); backdrop-filter: blur(5px);
          display: flex; justify-content: center; align-items: flex-end;
          z-index: 1000; transition: all 0.3s ease;
        }
        .timetable-modal-content {
          background: var(--bg-deep); color: var(--text-primary);
          width: 100%; max-height: 80vh; border-radius: 20px 20px 0 0; 
          padding: 15px 15px 80px 15px; overflow-y: auto;
          box-shadow: 0 -5px 20px rgba(0,0,0,0.5); border-top: 2px solid var(--gold-primary);
          animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
        }
        .modal-header {
          display: flex; justify-content: space-between; align-items: center;
          margin-bottom: 12px; border-bottom: 1px solid var(--glass-border); padding-bottom: 10px;
        }
        .timetable-list-container {
          background: var(--bg-card); border-radius: 10px; overflow: hidden;
          border: 1px solid var(--glass-border); position: relative;
        }
        
        .timetable-header-row {
          display: grid; grid-template-columns: 0.8fr 1.2fr 1.6fr 1.2fr 1.2fr;
          background: var(--gold-primary); color: #000; font-weight: bold;
          padding: 8px 4px; text-align: center; font-family: 'Noto Nastaliq Urdu', serif; font-size: 0.7rem;
        }
        .timetable-data-row {
          display: grid; grid-template-columns: 0.8fr 1.2fr 1.6fr 1.2fr 1.2fr;
          padding: 8px 4px; text-align: center; font-size: 0.65rem;
          border-bottom: 1px solid var(--glass-border); color: var(--text-primary);
          align-items: center; transition: all 0.3s ease;
        }

        .timetable-data-row.jummah-row {
          background: linear-gradient(90deg, rgba(39, 174, 96, 0.15), rgba(39, 174, 96, 0.05)); 
          border-right: 3px solid #27ae60;
        }
        .jummah-text {
          color: #2ecc71;
          font-weight: 900;
          text-shadow: 0 0 5px rgba(46, 204, 113, 0.4);
        }

        .timetable-data-row.active-roza {
          background: rgba(212, 175, 55, 0.2); 
          border: 2px solid var(--gold-primary); 
          font-weight: bold;
          transform: scale(1.04); 
          box-shadow: 0 5px 15px rgba(0,0,0,0.5);
          border-radius: 8px;
          margin: 6px 0;
          font-size: 0.75rem !important; 
          position: relative;
          z-index: 2;
        }
        .active-roza .jummah-text {
          font-size: 0.8rem;
        }
        
        .action-buttons-row {
          display: flex; gap: 8px; margin: 15px auto 0; width: 100%; justify-content: center;
        }
        .view-timetable-btn {
          background: linear-gradient(45deg, var(--gold-dim), var(--gold-primary));
          color: #000; border: none; padding: 10px 15px; border-radius: 20px;
          font-family: 'Noto Nastaliq Urdu', serif; font-size: 0.85rem; font-weight: bold;
          display: flex; align-items: center; justify-content: center; gap: 6px;
          cursor: pointer; box-shadow: 0 4px 15px rgba(212,175,55,0.3); width: 80%;
        }
        
        .ramadan-section-title {
          font-family: 'Noto Nastaliq Urdu', serif; color: var(--gold-primary);
          font-size: 1rem; margin: 20px 0 10px 0; display: flex; align-items: center; gap: 6px;
          text-shadow: 0 0 5px var(--gold-glow);
        }
        .masail-box {
          background: var(--glass-bg); border-right: 3px solid var(--gold-primary);
          border-radius: 8px; padding: 10px; margin-bottom: 8px; box-shadow: 0 2px 5px var(--glass-shadow);
        }
        
        .quran-arabic-font {
          font-family: 'Scheherazade New', 'Amiri', serif !important;
          font-size: 1.5rem; color: var(--gold-shiny); text-align: right; line-height: 2;
          text-shadow: 0 0 5px var(--gold-glow);
        }
        .indopak-urdu-font {
          font-family: 'Noto Nastaliq Urdu', serif !important;
          font-size: 0.75rem; color: var(--text-primary); line-height: 2; text-align: right;
        }

        .private-masail-btn {
          background: rgba(212, 175, 55, 0.1); border: 1px solid var(--gold-dim);
          border-radius: 8px; padding: 10px; width: 100%; display: flex;
          justify-content: space-between; align-items: center; cursor: pointer;
          transition: all 0.3s ease; margin-bottom: 8px; margin-top: 15px;
        }
        .private-masail-content {
          background: var(--bg-card); border: 1px dashed var(--gold-dim); border-top: none;
          border-radius: 0 0 8px 8px; padding: 10px; margin-top: -8px; margin-bottom: 10px;
          animation: slideDown 0.3s ease;
        }
        
        .masail-category-title {
           font-family: 'Noto Nastaliq Urdu', serif; color: var(--gold-shiny); 
           font-size: 0.85rem; border-bottom: 1px solid var(--glass-border); 
           padding-bottom: 5px; margin: 15px 0 8px 0; display: flex; align-items: center; gap: 6px;
        }
        .masail-category-title:first-child { margin-top: 4px; }

        .zikr-interactive-card {
          background: var(--glass-bg); border: 1px solid var(--glass-border);
          border-radius: 8px; margin-bottom: 8px; overflow: hidden; transition: all 0.3s ease;
        }
        .zikr-card-header {
          padding: 10px; display: flex; justify-content: space-between; align-items: center;
          cursor: pointer; background: rgba(0,0,0,0.1);
        }
        .zikr-card-body {
          padding: 10px; border-top: 1px dashed var(--gold-dim); animation: slideDown 0.3s ease;
        }
        .play-zikr-btn {
          background: var(--gold-primary); border: none; border-radius: 50%; width: 35px; height: 35px;
          display: flex; align-items: center; justify-content: center; color: #000; cursor: pointer;
          box-shadow: 0 2px 5px var(--gold-glow); transition: transform 0.2s;
        }
        .play-zikr-btn:active { transform: scale(0.9); }
        .astaghfar-counter {
          display: flex; flex-direction: column; align-items: center; justify-content: center;
          background: rgba(212, 175, 55, 0.1); padding: 8px 15px; border-radius: 10px; border: 1px solid var(--gold-dim);
        }

        @keyframes slideDown { from { opacity: 0; transform: translateY(-5px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
      `}</style>

      <div className="ramadan-container animate-fade-in" style={{padding: '10px 10px 80px 10px', direction: 'rtl'}}>
        
        <div className="flex-between" style={{display: 'flex', justifyContent: 'space-between', marginBottom: '10px'}}>
          <span className="location-badge" style={{direction: 'ltr', background: 'var(--glass-bg)', padding: '4px 10px', borderRadius: '15px', fontSize: '0.65rem', border: '1px solid var(--glass-border)', display: 'flex', alignItems: 'center', gap: '4px'}}>
             <MapPin size={12} color="var(--gold-primary)" /> {locationName}
          </span>
          <span style={{fontFamily: "'Noto Nastaliq Urdu', serif", color: 'var(--gold-primary)', fontWeight: 'bold', fontSize: '0.75rem'}}>
            {isRamadan ? `${currentRozaDay} رمضان المبارک` : "رمضان کی آمد آمد"}
          </span>
        </div>

        <div className="next-prayer-card" style={{border: '1px solid var(--gold-primary)', boxShadow: '0 5px 15px rgba(212, 175, 55, 0.1)', textAlign: 'center', padding: '15px 10px', borderRadius: '12px'}}>
           <h2 style={{fontFamily: "'Noto Nastaliq Urdu', serif", fontSize: '1rem', color: 'var(--text-secondary)', margin: '0 0 5px 0'}}>
              {nextEvent.title}
           </h2>
           <h1 className="countdown-timer" style={{direction: 'ltr', fontSize: '2.5rem', color: 'var(--gold-shiny)', margin: 0}}>
              {nextEvent.diff || "00:00:00"}
           </h1>
           
           <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '12px', borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '10px'}}>
              <div style={{textAlign: 'center', flex: 1, borderLeft: '1px solid rgba(255,255,255,0.1)'}}>
                 <Moon size={16} color="var(--text-muted)" style={{marginBottom: '4px'}} />
                 <div style={{fontFamily: "'Noto Nastaliq Urdu', serif", fontSize: '0.65rem', color: 'var(--text-muted)'}}>سحری ختم</div>
                 <div style={{fontFamily: "'Poppins', sans-serif", fontWeight: 'bold', fontSize: '0.9rem', direction: 'ltr'}}>{format12Hour(timings?.sehri)}</div>
              </div>
              <div style={{textAlign: 'center', flex: 1}}>
                 <Sun size={16} color="var(--gold-primary)" style={{marginBottom: '4px'}} />
                 <div style={{fontFamily: "'Noto Nastaliq Urdu', serif", fontSize: '0.65rem', color: 'var(--text-muted)'}}>افطار (مغرب)</div>
                 <div style={{fontFamily: "'Poppins', sans-serif", fontWeight: 'bold', fontSize: '0.9rem', direction: 'ltr'}}>{format12Hour(timings?.iftar)}</div>
              </div>
           </div>

           <div className="action-buttons-row">
              {/* ✅ Scanner yahan se poori tarah khatam kar diya gaya hai */}
              <button className="view-timetable-btn" onClick={() => setShowModal(true)}>
                <CalendarDays size={16} /> رمضان ٹائم ٹیبل دیکھیں
              </button>
           </div>
        </div>

        <div style={{background: 'var(--glass-bg)', border: '1px dashed var(--gold-primary)', borderRadius: '10px', padding: '10px', marginBottom: '15px', marginTop: '15px', textAlign: 'center'}}>
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '6px', marginBottom: '8px'}}>
               <Star size={14} color="var(--gold-primary)" />
               <span style={{fontFamily: "'Noto Nastaliq Urdu', serif", fontSize: '0.9rem', color: 'var(--text-primary)', fontWeight: 'bold'}}>{ashra.number}: عشرہ {ashra.name}</span>
               <Star size={14} color="var(--gold-primary)" />
            </div>
            <p className="quran-arabic-font" style={{textAlign: 'center', margin: '0 0 8px 0'}}>{ashra.dua}</p>
            
            <div style={{background: 'rgba(0,0,0,0.1)', padding: '8px', borderRadius: '8px', border: '1px solid rgba(212, 175, 55, 0.2)'}}>
               <p className="indopak-urdu-font" style={{color: 'var(--text-muted)', margin: 0, textAlign: 'center'}}>
                  <ShieldCheck size={12} color="var(--gold-primary)" style={{display: 'inline', verticalAlign: 'middle', marginLeft: '4px'}} />
                  {ashra.fazilat}
               </p>
            </div>
        </div>

        <div className="dynamic-dua-card exact-fazeelat-card" style={{marginBottom: '10px', borderRadius: '8px'}}>
          <div className="dua-card-header" style={{borderBottom: '1px solid var(--glass-border)', padding: '8px 10px'}}>
             <Clock size={14} className="icon-gold" style={{color: 'var(--gold-primary)'}} />
             <h3 style={{fontFamily: "'Noto Nastaliq Urdu', serif", fontSize: '0.85rem', margin: 0}}>{ramadanDuas.sehri.title}</h3>
          </div>
          <div className="dua-card-body" style={{padding: '10px'}}>
             <p className="quran-arabic-font" style={{margin: '0 0 5px 0'}}>{ramadanDuas.sehri.arabic}</p>
             <p className="indopak-urdu-font" style={{margin: 0}}>{ramadanDuas.sehri.urdu}</p>
          </div>
        </div>
        
        <div className="dynamic-dua-card exact-fazeelat-card" style={{borderRadius: '8px'}}>
          <div className="dua-card-header" style={{borderBottom: '1px solid var(--glass-border)', padding: '8px 10px'}}>
             <Heart size={14} className="icon-gold" style={{color: 'var(--gold-primary)'}} />
             <h3 style={{fontFamily: "'Noto Nastaliq Urdu', serif", fontSize: '0.85rem', margin: 0}}>{ramadanDuas.iftar.title}</h3>
          </div>
          <div className="dua-card-body" style={{padding: '10px'}}>
             <p className="quran-arabic-font" style={{margin: '0 0 5px 0'}}>{ramadanDuas.iftar.arabic}</p>
             <p className="indopak-urdu-font" style={{margin: 0}}>{ramadanDuas.iftar.urdu}</p>
          </div>
        </div>

        <h2 className="ramadan-section-title"><BookHeart size={18} /> رمضان کی خاص دعائیں</h2>
        {extraDuas.map((dua, index) => (
          <div key={index} className="dynamic-dua-card exact-fazeelat-card" style={{marginBottom: '10px', borderRadius: '8px'}}>
            <div className="dua-card-header" style={{borderBottom: '1px solid var(--glass-border)', padding: '8px 10px'}}>
               <h3 style={{fontFamily: "'Noto Nastaliq Urdu', serif", fontSize: '0.85rem', margin: 0}}>{dua.title}</h3>
            </div>
            <div className="dua-card-body" style={{padding: '10px'}}>
               <p className="quran-arabic-font" style={{margin: '0 0 5px 0'}}>{dua.arabic}</p>
               <p className="indopak-urdu-font" style={{margin: 0}}>{dua.urdu}</p>
            </div>
          </div>
        ))}

        <h2 className="ramadan-section-title"><MessageCircle size={18} /> روزمرہ کے اذکار</h2>
        
        <div className="zikr-interactive-card">
           <div className="zikr-card-header" onClick={() => toggleZikrAccordion('kalma')}>
              <div>
                 <h4 style={{fontFamily: "'Noto Nastaliq Urdu', serif", color: 'var(--text-primary)', margin: '0 0 3px 0', fontSize: '0.9rem'}}>{zikrData.kalma.title}</h4>
                 <p style={{margin: 0, fontSize: '0.65rem', color: 'var(--text-muted)', fontFamily: "'Noto Nastaliq Urdu', serif"}}>{zikrData.kalma.desc}</p>
              </div>
              {expandedZikr === 'kalma' ? <ChevronUp size={16} color="var(--gold-primary)" /> : <ChevronDown size={16} color="var(--gold-primary)" />}
           </div>
           {expandedZikr === 'kalma' && (
              <div className="zikr-card-body">
                 <p className="quran-arabic-font" style={{margin: '0 0 10px 0'}}>{zikrData.kalma.arabic}</p>
                 <p className="indopak-urdu-font" style={{marginBottom: '12px'}}>{zikrData.kalma.urdu}</p>
                 <div style={{display: 'flex', justifyContent: 'center'}}>
                    <button className="play-zikr-btn" onClick={() => toggleAudio('kalma')}>
                       {playingZikr === 'kalma' ? <Pause size={16} fill="currentColor" /> : <Play size={16} fill="currentColor" style={{marginLeft:'3px'}} />}
                    </button>
                 </div>
              </div>
           )}
        </div>

        <div className="zikr-interactive-card" style={{borderColor: expandedZikr === 'astaghfar' ? 'var(--gold-primary)' : 'var(--glass-border)'}}>
           <div className="zikr-card-header" onClick={() => toggleZikrAccordion('astaghfar')}>
              <div>
                 <h4 style={{fontFamily: "'Noto Nastaliq Urdu', serif", color: 'var(--gold-shiny)', margin: '0 0 3px 0', fontSize: '0.9rem'}}>{zikrData.astaghfar.title}</h4>
                 <p style={{margin: 0, fontSize: '0.65rem', color: 'var(--text-muted)', fontFamily: "'Noto Nastaliq Urdu', serif"}}>{zikrData.astaghfar.desc}</p>
              </div>
              {expandedZikr === 'astaghfar' ? <ChevronUp size={16} color="var(--gold-primary)" /> : <ChevronDown size={16} color="var(--gold-primary)" />}
           </div>
           {expandedZikr === 'astaghfar' && (
              <div className="zikr-card-body">
                 <p className="quran-arabic-font" style={{textAlign: 'center', margin: '0 0 10px 0', fontSize: '2rem'}}>{zikrData.astaghfar.arabic}</p>
                 <p className="indopak-urdu-font" style={{textAlign: 'center', marginBottom: '15px'}}>{zikrData.astaghfar.urdu}</p>
                 
                 <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px'}}>
                    <div className="astaghfar-counter">
                       <span style={{fontFamily: "'Noto Nastaliq Urdu', serif", fontSize: '0.7rem', color: 'var(--text-muted)'}}>پڑھا گیا</span>
                       <strong style={{fontSize: '1.4rem', color: 'var(--gold-primary)', fontFamily: "'Poppins', sans-serif"}}>{astaghfarCount} <span style={{fontSize:'0.8rem', color:'var(--text-muted)'}}>/100</span></strong>
                    </div>

                    <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                        <button className="play-zikr-btn" onClick={() => toggleAudio('astaghfar')} style={{width: '45px', height: '45px'}}>
                           {playingZikr === 'astaghfar' ? <Pause size={20} fill="currentColor" /> : <Play size={20} fill="currentColor" style={{marginLeft:'3px'}} />}
                        </button>
                        <button onClick={() => { setAstaghfarCount(0); document.getElementById('audio_astaghfar')?.pause(); setPlayingZikr(null); }} style={{background: 'transparent', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', fontSize: '0.65rem', fontFamily: "'Noto Nastaliq Urdu', serif"}}>
                            <RotateCcw size={10} /> ری سیٹ
                        </button>
                    </div>
                 </div>
              </div>
           )}
        </div>

        <div className="zikr-interactive-card">
           <div className="zikr-card-header" onClick={() => toggleZikrAccordion('durood')}>
              <div>
                 <h4 style={{fontFamily: "'Noto Nastaliq Urdu', serif", color: 'var(--text-primary)', margin: '0 0 3px 0', fontSize: '0.9rem'}}>{zikrData.durood.title}</h4>
                 <p style={{margin: 0, fontSize: '0.65rem', color: 'var(--text-muted)', fontFamily: "'Noto Nastaliq Urdu', serif"}}>{zikrData.durood.desc}</p>
              </div>
              {expandedZikr === 'durood' ? <ChevronUp size={16} color="var(--gold-primary)" /> : <ChevronDown size={16} color="var(--gold-primary)" />}
           </div>
           {expandedZikr === 'durood' && (
              <div className="zikr-card-body">
                 <p className="quran-arabic-font" style={{margin: '0 0 10px 0'}}>{zikrData.durood.arabic}</p>
                 <p className="indopak-urdu-font" style={{marginBottom: '15px'}}>{zikrData.durood.urdu}</p>
                 <div style={{display: 'flex', justifyContent: 'center'}}>
                    <button className="play-zikr-btn" onClick={() => toggleAudio('durood')}>
                       {playingZikr === 'durood' ? <Pause size={16} fill="currentColor" /> : <Play size={16} fill="currentColor" style={{marginLeft:'3px'}} />}
                    </button>
                 </div>
              </div>
           )}
        </div>

        <div className="zikr-interactive-card" onClick={openQuran} style={{cursor: 'pointer', background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.1), rgba(0,0,0,0))'}}>
           <div className="zikr-card-header" style={{background: 'transparent', border: 'none'}}>
              <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                 <div style={{background: 'var(--gold-primary)', padding: '8px', borderRadius: '10px', color: '#000'}}>
                    <BookOpen size={18} />
                 </div>
                 <div>
                    <h4 style={{fontFamily: "'Noto Nastaliq Urdu', serif", color: 'var(--gold-primary)', margin: '0 0 3px 0', fontSize: '0.9rem'}}>تلاوتِ قرآن</h4>
                    <p style={{margin: 0, fontSize: '0.65rem', color: 'var(--text-muted)', fontFamily: "'Noto Nastaliq Urdu', serif"}}>قرآن مجید پڑھنے کے لیے یہاں کلک کریں</p>
                 </div>
              </div>
           </div>
        </div>

        <h2 className="ramadan-section-title"><ListChecks size={18} /> روزے کے عام مسائل</h2>
        <div>
          {masailList.map((masla, index) => (
            <div key={index} className="masail-box">
               <p className="indopak-urdu-font" style={{margin: 0}}>{masla}</p>
            </div>
          ))}
        </div>

        <div className="private-masail-btn" onClick={() => setShowPrivateMasail(!showPrivateMasail)}>
           <div style={{display: 'flex', alignItems: 'center', gap: '6px', color: 'var(--gold-primary)', fontFamily: "'Noto Nastaliq Urdu', serif", fontSize: '0.85rem', fontWeight: 'bold'}}>
              <AlertCircle size={16} />
              مخصوص اور نجی مسائل (مرد و خواتین)
           </div>
           {showPrivateMasail ? <ChevronUp size={16} color="var(--gold-primary)" /> : <ChevronDown size={16} color="var(--gold-primary)" />}
        </div>
        
        {showPrivateMasail && (
          <div className="private-masail-content">
             <h3 className="masail-category-title">👩 خواتین کے مسائل</h3>
             {masailKhawateen.map((masla, index) => (
                <div key={`aurat-${index}`} style={{marginBottom: '10px', paddingBottom: '8px', borderBottom: '1px solid var(--glass-border)'}}>
                   <h4 style={{fontFamily: "'Noto Nastaliq Urdu', serif", color: 'var(--text-primary)', margin: '0 0 4px 0', fontSize: '0.8rem'}}>{masla.title}</h4>
                   <p className="indopak-urdu-font" style={{color: 'var(--text-muted)', margin: 0}}>{masla.desc}</p>
                </div>
             ))}

             <h3 className="masail-category-title" style={{marginTop: '15px'}}>👨 مردوں کے مسائل</h3>
             {masailMard.map((masla, index) => (
                <div key={`mard-${index}`} style={{marginBottom: '10px', paddingBottom: '8px', borderBottom: '1px solid var(--glass-border)'}}>
                   <h4 style={{fontFamily: "'Noto Nastaliq Urdu', serif", color: 'var(--text-primary)', margin: '0 0 4px 0', fontSize: '0.8rem'}}>{masla.title}</h4>
                   <p className="indopak-urdu-font" style={{color: 'var(--text-muted)', margin: 0}}>{masla.desc}</p>
                </div>
             ))}

             <h3 className="masail-category-title" style={{marginTop: '15px'}}>👫 میاں بیوی کے مشترکہ مسائل</h3>
             {masailShared.map((masla, index) => (
                <div key={`shared-${index}`} style={{marginBottom: index !== masailShared.length - 1 ? '10px' : '0', paddingBottom: index !== masailShared.length - 1 ? '8px' : '0', borderBottom: index !== masailShared.length - 1 ? '1px solid var(--glass-border)' : 'none'}}>
                   <h4 style={{fontFamily: "'Noto Nastaliq Urdu', serif", color: 'var(--text-primary)', margin: '0 0 4px 0', fontSize: '0.8rem'}}>{masla.title}</h4>
                   <p className="indopak-urdu-font" style={{color: 'var(--text-muted)', margin: 0}}>{masla.desc}</p>
                </div>
             ))}
          </div>
        )}

      </div>

      {showModal && (
        <div className="timetable-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="timetable-modal-content" onClick={(e) => e.stopPropagation()}>
            
            <div className="modal-header" style={{flexDirection: 'column', alignItems: 'flex-start', position: 'relative'}}>
              <div style={{display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center'}}>
                 <h2 style={{fontFamily: "'Noto Nastaliq Urdu', serif", color: 'var(--gold-primary)', margin: 0, fontSize: '1rem'}}>
                    رمضان المبارک ٹائم ٹیبل
                 </h2>
                 <button onClick={() => setShowModal(false)} style={{background:'transparent', border:'none', color:'var(--text-primary)', cursor:'pointer', padding: 0}}>
                   <X size={18} />
                 </button>
              </div>

              {/* ✅ NAYA ADD KIYA GAYA NOTE MAI HAWALA (Surah Al-Baqarah: 187) */}
              <div style={{background: 'rgba(212, 175, 55, 0.1)', border: '1px dashed var(--gold-dim)', borderRadius: '8px', padding: '10px', marginTop: '15px', width: '100%'}}>
                 <div style={{display: 'flex', alignItems: 'flex-start', gap: '6px'}}>
                    <AlertCircle size={16} color="var(--gold-primary)" style={{flexShrink: 0, marginTop: '2px'}} />
                    <p style={{fontFamily: "'Noto Nastaliq Urdu', serif", color: 'var(--text-secondary)', fontSize: '0.75rem', lineHeight: '1.6', margin: 0, textAlign: 'justify'}}>
                       <strong>نوٹ:</strong> سحری اور افطار کے اوقات میں کیلنڈر کے حساب سے چند منٹ کا فرق ہو سکتا ہے۔ قرآن مجید میں ہے: <span style={{color: 'var(--gold-shiny)'}}>"کھاؤ اور پیو یہاں تک کہ فجر کی سفید دھاری رات کی سیاہ دھاری سے نمایاں ہو جائے" (البقرہ: 187)</span>۔ لہٰذا مقامی وقت اور اذان پر عمل کریں، اس معمولی فرق سے روزے میں کوئی مسئلہ نہیں ہوتا۔
                    </p>
                 </div>
              </div>
            </div>

            <div className="timetable-list-container">
               <div className="timetable-header-row" style={{direction: 'rtl'}}>
                 <div>روزہ</div>
                 <div>دن</div>
                 <div>تاریخ</div>
                 <div>سحری</div>
                 <div>افطار</div>
               </div>
               
               <div style={{direction: 'ltr'}}> 
                 {timetable.map((dayObj, index) => {
                    const rozaNumber = index + 1;
                    const isToday = isRamadan && currentRozaDay === rozaNumber;
                    const dateStr = dayObj.date.gregorian.date; 
                    
                    const dayEn = dayObj.date.gregorian.weekday.en;
                    const dayUr = urduDays[dayEn] || dayEn;
                    const isJummah = dayEn === "Friday";

                    const sehriTime = format12Hour(dayObj.timings.Imsak.split(' ')[0]);
                    const iftarTime = format12Hour(dayObj.timings.Maghrib.split(' ')[0]);

                    return (
                      <div key={index} className={`timetable-data-row ${isJummah ? 'jummah-row' : ''} ${isToday ? 'active-roza' : ''}`} style={{direction: 'rtl'}}>
                         <div style={{fontFamily: "'Noto Nastaliq Urdu', serif"}}>{rozaNumber}</div>
                         <div className={isJummah ? 'jummah-text' : ''} style={{fontFamily: "'Noto Nastaliq Urdu', serif"}}>{dayUr}</div>
                         <div style={{fontFamily: "'Poppins', sans-serif"}}>{dateStr}</div>
                         <div style={{fontFamily: "'Poppins', sans-serif", direction: 'ltr'}}>{sehriTime}</div>
                         <div style={{fontFamily: "'Poppins', sans-serif", direction: 'ltr'}}>{iftarTime}</div>
                      </div>
                    )
                 })}
                 {timetable.length === 0 && (
                   <div style={{padding: '15px', textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.75rem'}}>
                     ڈیٹا لوڈ ہو رہا ہے...
                   </div>
                 )}
               </div>
            </div>

          </div>
        </div>
      )}
    </>
  );
};

export default RamadanTimes;